export default {
  list: null,
  selected: null,
  toUpdate: false
}



// WEBPACK FOOTER //
// ./src/features/PerguntaGrupo/store/state.js